import React from "react";
import useSelector from "../../util/hooks/useSelector";
import { Col } from "antd";
import classNames from "classnames";

type Props = {
    contentTheme: 'dark' | 'light'
}

const SupportContent = ({
    contentTheme
}: Props) => {
    const { user } = useSelector((state) => state.user);
    
    return (
        <>
            { !!user?.accountManagerName && (
                <Col 
                    xs={24}
                    className={
                        classNames(
                            "gx-d-flex gx-flex-column gx-mb-3",
                            {
                                "custom-help-order__wrapper": contentTheme === "light"
                            }
                        )
                    }
                >
                    <div className="custom-help-order__text">
                        Ваш персональный менеджер:<br/>
                        { user?.accountManagerName }
                    </div>
                </Col>
            ) }
            <Col 
                xs={24}
                className={
                    classNames(
                        "gx-d-flex gx-flex-column gx-mb-3",
                        {
                            "custom-help-order__wrapper": contentTheme === "light"
                        }
                    )
                }
            >
                <div className="custom-help-order__text">
                    Подбор тарифа, другие вопросы развития:<br/>
                    { !!user?.accountManagerName && (
                        <a href="tel:+79014170997" className="custom-help-order__phone gx-ml-0">+7 (901) 417-09-97</a>
                    ) || (
                        <a href="tel:+79587779996" className="custom-help-order__phone gx-ml-0">+7 (958) 777-99-96</a>
                    ) }
                </div>
            </Col>
            <Col 
                xs={24}
                className={
                    classNames(
                        "gx-d-flex gx-flex-column",
                        {
                            "custom-help-order__wrapper": contentTheme === "light"
                        }
                    )
                }
            >
                <div className="custom-help-order__text">
                    Клиентский отдел:<br/>
                    <a href="tel:+74951210799" className="custom-help-order__phone gx-ml-0">+7 (495) 121-07-99</a>
                </div>
            </Col>
        </>
    )
}

export { SupportContent };